import EmailLink, { EmailLinkProps } from "components/Shared/EmailLink";
import { CONTACT_EMAIL } from "utils/config";

export default function ContactEmailLink(props: Omit<EmailLinkProps, "email">) {
  return <EmailLink email={CONTACT_EMAIL} {...props} />;
}
